import { useTranslation } from "@opendash/i18n";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../context/PathContext";
import { ConfigInputProps } from "../../types/Config";
import { PlaceholderInput } from "./default/PlaceholderInput";

type Props = {} & ConfigInputProps<"description">;

export const DescriptionConfigInput = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <>
      <PlaceholderInput />
    </>
  );
});
